class AceiteTermoDeUsoService extends EficienciaFiscalAbstractService

  configure: (configs, injector) ->
    configs.url = '/eficiencia-fiscal/aceite-termo-de-uso'
    configs.callFunction =
      method: 'PUT'
      holder: 'function'

    super(configs, injector)

  aceitarTermo: (data, callback) ->
    @callFunction('aceitar_termo', data, callback, {blockScreen: true})

angular.module('eficienciaFiscalModule').service('aceiteTermoDeUsoService', AceiteTermoDeUsoService)
